import React, { useState } from 'react';
import { useMutation, gql } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

const CREATE_VENUE = gql`
  mutation CreateVenuePage($input: VenuePageInput!) {
    CreateVenuePage(input: $input) {
      id
      name
      slug
    }
  }
`;

const CreateVenueForm = () => {
  const navigate = useNavigate();
  const token = sessionStorage.getItem('token');
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
    latitude: '',
    longitude: '',
    description: '',
  });

  const [createVenue, { loading, error }] = useMutation(CREATE_VENUE, {
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    onCompleted: (data) => {
      navigate(`/venuedashboard/${data.CreateVenuePage.id}`);
    },
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    createVenue({
      variables: {
        input: {
          ...formData,
          latitude: parseFloat(formData.latitude),
          longitude: parseFloat(formData.longitude),
        },
      },
    });
  };

  return (
    <div style={{ color: 'white', padding: 20 }}>
      <h2>Create a Venue</h2>
      <form onSubmit={handleSubmit}>
        {Object.keys(formData).map((field) => (
          <input
            key={field}
            type="text"
            name={field}
            placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
            value={formData[field]}
            onChange={handleChange}
            required={['name', 'address', 'city', 'state', 'postalCode', 'country', 'latitude', 'longitude'].includes(field)}
          />
        ))}
        <button type="submit" disabled={loading}>
          {loading ? 'Creating...' : 'Create Venue'}
        </button>
      </form>
      {error && <p style={{ color: 'red' }}>{error.message}</p>}
    </div>
  );
};

export default CreateVenueForm;
